import { render } from "./ReceiptUploadingNote.vue?vue&type=template&id=ff6fb69c&ts=true"
import script from "./ReceiptUploadingNote.vue?vue&type=script&lang=ts"
export * from "./ReceiptUploadingNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__